import React, { useEffect, useRef } from "react";

const AddCompanyLinkModal = ({ show, onClose, onSave, newLink, handleOnchange, isAdding }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const modal = modalRef.current;
    if (!modal) return;

    if (show) {
      modal.style.display = "block";
      setTimeout(() => {
        modal.classList.add("show");
      }, 10);
    } else {
      modal.classList.remove("show");
      setTimeout(() => {
        modal.style.display = "none";
      }, 150);
    }
  }, [show]);

  return (
    <div
      ref={modalRef}
      className="modal fade"
      tabIndex="-1"
      style={{ display: "none" }} 
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add New Company Link</h5>
            <button type="button" className="btn-close btn-sm" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={newLink.name}
                onChange={(e)=>handleOnchange("name", e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">URL</label>
              <input
                type="text"
                className="form-control"
                value={newLink.url}
                onChange={(e)=>handleOnchange("url", e.target.value)}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-add" onClick={onSave} disabled={isAdding}>
              {isAdding ? "Adding..." : "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCompanyLinkModal;
